/**
 * @desc 辅助加载工具
 */
import Loader from 'z-loader';
import Vue from 'vue';
import {vendorUrl, componentUrl, moduleUrl} from '@/global';

const loader = new Loader({
  sourceUrl: vendorUrl,
  dependencies: {Promise},
});
Vue.use(loader);
export const componentLoader = new Loader({
  sourceUrl: componentUrl,
  dependencies: {Promise},
});
export const moduleLoader = new Loader({
  sourceUrl: moduleUrl,
  dependencies: {Promise},
});
export const vueComponentLoader = (name, option = {}) => componentLoader.loadVueComponent(name, {
  dependencies: [Vue],
  hasStyle: true,
  ...option,
});
export default loader;
